/* Size Guide Modal — Unified v2.0.0 */
(function() {
  'use strict';

  var modal = document.getElementById('size-guide-modal');
  if (!modal) return;

  var tabs = modal.querySelectorAll('[data-sg-tab]');
  var panels = modal.querySelectorAll('[data-sg-panel]');
  var closeButtons = modal.querySelectorAll('[data-sg-close]');
  var sizeButtons = modal.querySelectorAll('[data-sg-select]');

  function openModal() {
    modal.classList.add('sg-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    /* Sync with HP PDP active system if present */
    var pdp = document.querySelector('.hp-pdp');
    if (pdp && pdp.dataset.activeSystem) {
      switchTab(pdp.dataset.activeSystem);
    }
  }

  function closeModal() {
    modal.classList.remove('sg-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function switchTab(system) {
    tabs.forEach(function(tab) {
      var isActive = tab.getAttribute('data-sg-tab') === system;
      tab.classList.toggle('sg-modal__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    panels.forEach(function(panel) {
      var isActive = panel.getAttribute('data-sg-panel') === system;
      panel.classList.toggle('sg-modal__panel--active', isActive);
      if (isActive) { panel.removeAttribute('hidden'); }
      else { panel.setAttribute('hidden', ''); }
    });
  }
  /* Select size and sync with PDP variant selector */
  function selectSize(sizeCode) {
    var pdp = document.querySelector('.hp-pdp');
    if (!pdp) { closeModal(); return; }

    var system = sizeCode.startsWith('CAR') ? 'sentinel' : 'guardian';
    var systemBtn = pdp.querySelector('[data-system="' + system + '"]');
    if (systemBtn && !systemBtn.classList.contains('active')) {
      systemBtn.click();
    }

    setTimeout(function() {
      var sizeBtn = pdp.querySelector('[data-size="' + sizeCode + '"]');
      if (sizeBtn) {
        sizeBtn.click();
        sizeBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      closeModal();
    }, 50);
  }

  /* Tab click handlers */
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      switchTab(this.getAttribute('data-sg-tab'));
    });
  });

  /* Close handlers */
  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', closeModal);
  });

  /* Size selection handlers */
  sizeButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      selectSize(this.getAttribute('data-sg-select'));
    });
  });

  /* Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('sg-modal--open')) {
      closeModal();
    }
  });

  /* Global API */
  window.sizeGuideModal = { open: openModal, close: closeModal };

  /* Attach triggers — supports all legacy selectors */
  var TRIGGER_SELECTOR = [
    '[data-sg-trigger]',
    '[data-hp-sg-trigger]',
    '[data-open-size-guide]',
    '[data-modal-open="vehicle-fit-guide"]',
    '.product__size-guide-trigger',
    '.hp-pdp__size-guide-link'
  ].join(',');

  function attachTriggers() {
    document.querySelectorAll(TRIGGER_SELECTOR).forEach(function(el) {
      if (el.hasAttribute('data-sg-attached')) return;
      el.setAttribute('data-sg-attached', 'true');
      el.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
    });
  }

  attachTriggers();

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(attachTriggers)
      .observe(document.body, { childList: true, subtree: true });
  }
})();